import { useEffect } from 'react';

// ── Raccourcis clavier globaux ─────────────────────────────────────────────
// N → nouvelle BD | F → focus recherche | Échap → fermer modales
export function useKeyboard({ onNew, onFocusSearch, onEscape, enabled = true }) {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e) => {
      // Ignorer si on est dans un champ de saisie
      const tag = document.activeElement?.tagName;
      const inInput = ['INPUT','TEXTAREA','SELECT'].includes(tag);

      if (e.key === 'Escape' && onEscape) {
        onEscape();
        return;
      }
      if (inInput) return;

      if (e.key === 'n' || e.key === 'N') { e.preventDefault(); onNew?.(); }
      if (e.key === 'f' || e.key === 'F') { e.preventDefault(); onFocusSearch?.(); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onNew, onFocusSearch, onEscape, enabled]);
}
